import styled from 'styled-components'
import { Column } from '../../../styles/styledGlobal'

export const MainColumn = styled(Column)<{padding: string, width: string}>`
padding: ${props => props.padding};
width: ${props => props.width};
box-shadow: var(--SombraBackground);
background: white;
`

export const ColumnTitle = styled(Column)`
margin: 1rem 0rem;

h2{
    color:var(--a3);
}
`

export const MainContainer = styled.div`
display: flex;
flex-direction: column;
width: 60%;
`

export const PreviewEtapaContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(1,1fr);
    gap: .8rem .8rem;    
    max-width: 43rem;
`

export const HeadPreview = styled.div`
display: flex;
align-items: center;
margin-bottom: 1rem;

span{
    font-weight: 500;
    font-size: 18px;
}
svg{
    margin-right: 1rem;
}
`
